import axiosInstance from "../../../api/axiosConfig";

export const getSampleCategories = (params: any) => {
  return axiosInstance.get("/admin/sample-categories", {
    params: params,
  });
};

export const deleteSampleCategory = (id: string) => {
  return axiosInstance.delete(`/admin/sample-categories/${id}`);
};
